<template>
  <v-modal
    v-if="show"
    :show="show"
    @update:show="$emit('update:show', $event)"
    :isTableModal="true"
  >
    <h4 slot="header" class="title title-up">
      Rundmail Einstellungen (ID: {{ id }})
    </h4>
    <resource
      resource="circularMail"
      :original="circularMail"
      :static-mode="true"
      :attributes="[
        {
          name: 'sender_info|name',
          label: 'Absender',
          type: 'StaticText'
        },
        {
          name: 'circular_mail_messages',
          label: 'Nachrichtenelemente',
          type: 'MessageElementsSelector'
        },
        {
          name: 'send_at',
          label: 'Versenden am',
          type: 'DateTimeSelector',
          value: null
        },

        {
          name: 'age',
          label: 'Alter',
          type: 'MultiSliderSelector',
          max: 125,
          min: 18,
          isFilter: true
        },
        {
          name: 'send_to_gender',
          label: 'Geschlecht',
          type: 'SexSelector',
          multiSelect: true,
          isFilter: true
        },
        {
          name: 'photo',
          label: 'Foto',
          type: 'OptionSelector',
          isFilter: true
        },
        {
          name: 'registered_from',
          label: 'Registriert von',
          type: 'DateSelector',
          isFilter: true
        },
        {
          name: 'registered_to',
          label: 'Registriert bis',
          type: 'DateSelector',
          isFilter: true
        },
        {
          name: 'max_days_offline',
          label: 'Tage letzter Login',
          type: 'UserActivitySelector',
          max: circularmailOfflineDays,
          min: 0,
          isFilter: true
        },
        {
          name: 'transaction',
          label: 'Käufe',
          type: 'OptionSelector',
          isFilter: true
        },
        {
          name: 'spent',
          label: spendLabel,
          type: 'number',
          isFilter: true
        }
      ]"
    >
    </resource>
  </v-modal>
</template>

<script lang="babel">
import { Modal } from "src/components/UIComponents";
export default {
  data() {
    return {
      circularMail: [],
    };
  },
  components: {
    'v-modal': Modal
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      required: true
    }
  },
  computed: {
    circularmailOfflineDays() {
      return Laravel.settings.circularmailOfflineDays;
    },
    only_non_active_member_label() {
      return 'Nur Mitglieger die länger als '+ Laravel.settings.mail.offline_disable + ' Tage offline sind';
    },
    days_for_offline_summary() {
      return Laravel.settings.mail.offline_summary;
    },
    spendLabel() {
      return 'Bereits ausgegebene '+Laravel.lang.currency;
    }
  },
  created() {
    this.circularMail = this.$attrs;
    this.circularMail.age = [this.circularMail.age_from, this.circularMail.age_to];
    this.circularMail.send_to_gender =  JSON.parse(this.circularMail.send_to_gender);
    if (this.circularMail.max_days_offline == "[-1,-1]") {
      this.circularMail.max_days_offline = true;
    } else {
      this.circularMail.max_days_offline = JSON.parse(this.circularMail.max_days_offline);
    }
  },
};
</script>
